// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".resp-container{overflow:hidden;border-radius:4px}.resp-container,.resp-iframe{position:relative;height:100%}.resp-iframe{top:0;left:0;width:100%;border:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
